import storage from 'localforage';
import join from 'url-join';

import { history, createAction, asyncAction, http } from '../util';
import { setGlobalHeader } from '../util/http';
import { isOffline } from '../offline/reducer';
import { loadUser } from '../user/actions';

import { invoicePermissions } from '../util/rolePermissions';
import { LOCALE_USA } from '../static/languagePicker/constants';

const locationKey = 'location';
const routeStore = storage.createInstance({ name: 'route-store ' });
const api = join(import.meta.env.VITE_API_URL, 'v1');

export const startAuthCheck = createAction('AUTH_CHECK_START', { noPayload: true });
export const finishAuthCheck = createAction('AUTH_CHECK_COMPLETE', { noPayload: true });
export const setUserLogin = createAction('LOGIN_SET_USER');
export const startLogin = createAction('LOGIN_START');
export const tokenSuccess = createAction('CONFIRM_TOKEN_SUCCESS');

export const getUserInvoiceAuth = asyncAction({
  baseName: 'GET_USER_INVOICE_AUTH',
  action: action => ({ language, locale, role, soldTo, token, userId, username }) => dispatch => {
    const values = {
      sub: username,
      NikeAuthToken: token,
      gauth: invoicePermissions[role],
      ast: soldTo,
      userId: userId,
      // NOTE: This is a fail-safe to ensure iPaid invoices pre-auth works
      // TODO: Eventually refactor language/locale use for users
      lang: language || (locale && locale.split('_')[0]) || LOCALE_USA.split('_')[0],
      isImpersonating: false
    };
    dispatch(action.start(values));
    return http
      .post(join(import.meta.env.VITE_INVOICE_AUTH, '/token/user/createByClaims'), values)
      .then(({ data: response }) => {
        // Remove iPaid token on logout
        document.cookie = `NikeGamedayToken=${response.jwt};domain=.nike.net;path=/`;
        return dispatch(action.success(response));
      })
      .catch(error => dispatch(action.error({ error })));
  }
});

export const initializeUserAuth = oktaAuth => async (dispatch, getState) => {
  const state = getState();
  dispatch(startAuthCheck());

  const tokens = await oktaAuth.tokenManager.getTokens();

  const {
    accessToken: { accessToken }
  } = tokens;

  if (!accessToken) {
    if (isOffline(state)) {
      dispatch(finishAuthCheck());
      return;
    }
    return;
  }

  setGlobalHeader('Authorization', `Bearer ${accessToken}`);

  document.cookie = `NikeOktaToken=${accessToken};domain=.nike.net;path=/`;

  // Load user profile and set to local storage
  dispatch(loadUser());

  // TODO: Configure your HTTP client to use the token here

  // Set token
  dispatch(setUserLogin(accessToken));

  routeStore
    .getItem(locationKey)
    .then(previousRoute => {
      if (previousRoute) {
        history.replace(previousRoute);
        routeStore.removeItem(locationKey);
      }
    })
    .then(() => dispatch(finishAuthCheck()));
};

export const migrateConfirmToken = asyncAction({
  baseName: 'CONFIRM_TOKEN',
  action: action => values => dispatch => {
    dispatch(action.start(values));
    const { token } = values;
    return http
      .get(join(api, `/legacy/migrate/confirm/email/${token}`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const inviteConfirmToken = asyncAction({
  baseName: 'CONFIRM_TOKEN',
  action: action => values => dispatch => {
    dispatch(action.start(values));
    const { token } = values;
    return http
      .get(join(api, `/invite/confirm/email/${token}`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});

export const expireInvoiceAuth = asyncAction({
  baseName: 'EXPIRE_INVOICE_AUTH',
  action: action => () => dispatch => {
    dispatch(action.start());
    return http
      .cookiePost(join(api, '/cookie'), {
        cookieName: 'NikeGamedayToken',
        cookieValue: 'expired',
        deleteCookie: 'true'
      })
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});
